export enum RequestStatus {
  Rejected = 0,
  Approved = 1,
  Requested = 2,
  Feedback = 3,
}

export enum RequestType {
  Request = 0,
  UpdateRequest,
  Message,
}

export class RequestModel {
  constructor(
    public id: string,
    public applicationId: string,
    public username: string,
    public createdAt: Date,
    public fieldsValue: string,
    public message: string,
    public fromClient: boolean,
    public status: RequestStatus,
    public type: RequestType
  ) {}
}
